import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"ma-0 pa-2"},[_c('router-view',{attrs:{"appointment":_vm.selectedAppointment},on:{"onAppointmentChanged":_vm.onAppointmentChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }